import React, { useEffect } from 'react';
import { Table } from 'reactstrap';
import moment from 'moment';
import { hotelInformation } from './constants';
import { useHotelBooking } from '../context/HotelBookingContext';
import './HotelInformation.scss';

function HotelInformation({ data }) {
  const { setHotelInfo } = useHotelBooking();
  useEffect(() => {
    setHotelInfo(data);
  }, [setHotelInfo, data]);

  const renderHotelInformationBody = () => {
    if (!data || data?.length === 0) {
      return (
        <tr>
          <td colSpan="6" className="text-center">
            No hotel information available.
          </td>
        </tr>
      );
    }
    return data?.map((hotel, index) => (
      <tr key={index}>
        <td>{hotel?.Country_Description}</td>
        <td>{hotel?.Place}</td>
        <td>{moment(hotel?.CheckInDate).format('L')}</td>
        <td>{moment(hotel?.CheckOutDate).format('L')}</td>
        <td>{hotel?.HotelName}</td>
        <td>{hotel?.ClientHotel}</td>
      </tr>
    ));
  };

  return (
    <div className="d-flex flex-column gap-2">
      <div>
        <span className="fw-semibold">Hotel Information</span>
      </div>
      <div className="table-responsive">
        <Table className="ba-table">
          <thead>
            <tr>
              {hotelInformation.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>{renderHotelInformationBody()}</tbody>
        </Table>
      </div>
    </div>
  );
}

export default HotelInformation;
